<template>
  <div id="about-view">
    <section class="bg-light">
      <main>
        <article class="container py-5 about-content">
          <h1>About Govava</h1>

          <p>
            Govava is an AI-powered gifting ecosystem built to eliminate the
            guesswork of choosing a gift — for individuals and for businesses.
          </p>

          <h2>What we do</h2>
          <p>
            Govava uses deep personality profiling and lifestyle mapping — a form
            of personalization AI — to match gift recipients to products, rather
            than relying on generic keyword search or manual wishlists. Think of it
            as an AI shopping assistant purpose-built for gifting. A dedicated Pet
            Wizard extends the same profiling approach to gifts for pets. The
            underlying persona-matching methodology is protected by a U.S. patent.
          </p>
          <p>
            Govava connects to more than 3,000 retail stores through the Rakuten
            network, with direct integrations into Amazon, Etsy, and Walmart — so
            recommendations lead directly to real, purchasable products. That
            combination of AI-driven matching and broad retail reach places Govava
            in the growing AI ecommerce and retail technology space.
          </p>

          <h2>B2C and B2B</h2>
          <ul>
            <li>
              <strong>For individuals:</strong> Govava profiles the recipient
              — their personality, hobbies, and unstated preferences — and
              surfaces gift ideas that feel personally chosen, not
              algorithmically generic.
            </li>
            <li>
              <strong>For businesses:</strong> The same personalization engine
              powers corporate gifting and employee or client recognition
              programs, so recognition at scale still feels individual rather
              than bulk-purchased.
            </li>
          </ul>

          <h2>Meet Ava</h2>
          <p>
            Ava is Govava's conversational assistant — built on real-time AI so
            conversations feel natural rather than turn-based. Powered by voice AI
            technology and an AI avatar front end, Ava represents Govava's broader
            investment in conversational AI development, extending the gifting
            experience into conversational commerce rather than static forms or
            menus.
          </p>

          <h2>How it works</h2>
          <p>
            Read more on our <router-link to="/faq">FAQ / How It Works</router-link>
            page.
          </p>
        </article>
      </main>
    </section>
  </div>
</template>

<script>
const SERVICE_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Service",
  serviceType: "AI Gift Recommendation Platform",
  provider: {
    "@type": "Organization",
    name: "Govava",
  },
  areaServed: "US",
  audience: [
    { "@type": "Audience", audienceType: "Consumers" },
    { "@type": "Audience", audienceType: "Businesses" },
  ],
};

export default {
  name: "AboutView",
  metaInfo: {
    title: "About Govava | AI-Powered Personal and Corporate Gifting",
    meta: [
      {
        name: "description",
        content:
          "Learn how Govava uses personality profiling and lifestyle mapping for personalized B2C and B2B gift recommendations across 3,000+ stores.",
      },
    ],
    link: [{ rel: "canonical", href: "https://www.govava.com/site/about_us" }],
    script: [
      { type: "application/ld+json", json: SERVICE_SCHEMA },
    ],
  },
};
</script>

<style scoped>
.about-content {
  max-width: 900px;
  color: #2c3e50;
  font-size: 1.05rem;
  line-height: 1.7;
}

.about-content h1,
.about-content h2 {
  margin-bottom: 1rem;
}

.about-content h2 {
  margin-top: 2rem;
}

.about-content li {
  margin-bottom: 1rem;
}
</style>
